import Base from './base'

export default class Search extends Base {
  search(data: object = {}) {
    return this.apiClient.get('search', data)
  }
}
